import React from 'react';
import './coachInlineTyping.css';

// Shared Today cue: saved prose stays intact while any Coach work is pending.
// Unrelated chat/review dots remain independent of daily insight ownership.
export const CoachInlineTyping = ({ name = 'Coach' }) => (
  <div className="coach-inline-typing" role="status" aria-label={`${name} is typing`}>
    <span /><span /><span />
  </div>
);
